import { Vessel } from '@app-types/index';
import { localStorageService } from './local-storage.service';

class VesselService {
  /**
   * Get all vessels from local storage
   */
  async getAll(): Promise<Vessel[]> {
    return localStorageService.getAll();
  }

  /**
   * Get a single vessel by ID
   */
  async get(vesselID: string | number): Promise<Vessel | null> {
    return localStorageService.get(vesselID);
  }

  /**
   * Save a vessel
   */
  async save(vessel: Vessel): Promise<Vessel> {
    return localStorageService.save(vessel);
  }

  /**
   * Save multiple vessels
   */
  async saveAll(vessels: Vessel[]): Promise<void> {
    return localStorageService.saveAll(vessels);
  }

  /**
   * Remove a vessel by ID
   */
  async remove(vesselID: string | number): Promise<void> {
    return localStorageService.remove(vesselID);
  }

  /**
   * Clear all vessels
   */
  async removeAll(): Promise<void> {
    return localStorageService.removeAll();
  }

  /**
   * Get count of vessels
   */
  async count(): Promise<number> {
    return localStorageService.count();
  }
}

// Export singleton instance
export const vesselService = new VesselService();
export default VesselService;
